#import "../fragments/analytics-status-fragment.graphql"

query GetAnalyticsStatus {
    analyticsStatus {
        ...AnalyticsStatusFragment
    }
}
